export default "__VITE_ASSET__CqSayt2w__"